import * as tools from '../Tools'

export class ToggleButton {
    public static buttons : Array<ISwichtButton> = [];

    constructor() {
        document
            .querySelectorAll('input.toggle-button')
            .forEach((button: HTMLInputElement) => this.initButton(button));
    }

    initButton(button: HTMLInputElement) {
        const switchButton = $(button).bootstrapSwitch({
            onText: button.dataset.on,
            offText: button.dataset.off,
            onInit: (ev, state) => this.evInit(button) ,
            onSwitchChange: (ev, state) => this.evChange(button, state)
        });
        ToggleButton.buttons.push(<ISwichtButton><any>switchButton);
    }

    async evInit(button: HTMLInputElement) {
        if (button.dataset.label) {
            (<HTMLElement>button.parentElement.querySelector('.bootstrap-switch-label')).title = button.dataset.label;
        }
    }

    async evChange(button, state) {
        if (button.dataset.action) {
            const data = await tools.fetchJSON(button.dataset.action + '/' + state);
            if (data.result) {
                const details: IToggleButtonStateChange = {
                    result: data,
                    state: state,
                    button: button
                };
                const evToggleButtonStateChange = new CustomEvent('evToggleButtonStateChange',{
                    detail: details
                });
                window.dispatchEvent(evToggleButtonStateChange);
            }
        }
    }
}
